import React, { useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "store/hooks/hooks";
import {
  selectAuthModal,
  closeModal,
  setStep,
  setEmail,
} from "store/slices/authModalSlice";
import ModalLayout from "./ModalLayout";
import SignInForm from "./SignInModal";
import SignUpForm from "./SignUpModal";
import VerifyEmail from "./VerifyModal";
import { AnimatePresence, motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";

const AuthModal: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const [title, setTitle] = useState("Sign In");
  const { isOpen, step, email } = useAppSelector(selectAuthModal);
  const [isSubmittingForm, setIsSubmittingForm] = useState(false);

  const handleClose = () => {
    dispatch(closeModal());
  };

  const switchToSignIn = () => dispatch(setStep("signin"));
  const switchToSignUp = () => dispatch(setStep("signUp"));

  const handleSignupSuccess = (userEmail: string) => {
    dispatch(setEmail(userEmail));
    dispatch(setStep("verifyOtp"));
  };

  const handleSwitchToVerifyEmail = (userEmail: string) => {
    dispatch(setEmail(userEmail));
    dispatch(setStep("verifyOtp"));
  };

  const handleOtpSuccess = () => {
    dispatch(setStep("signin"));
  };

  useEffect(() => {
    formTitle(step);
  }, [step]);

  const formTitle = (step: string) => {
    if (step === "signin") {
      setTitle("Sign In");
    } else if (step === "signUp") {
      setTitle("Sign Up");
    } else if (step === "verifyOtp") {
      setTitle("Verify OTP");
    }
  };

  return (
    <ModalLayout
      isOpen={isOpen}
      onClose={handleClose}
      title={title}
      disableCloseButton={isSubmittingForm}
      closeOnOutsideClick={!isSubmittingForm}
    >
      <AnimatePresence mode="wait" initial={false}>
        <motion.div
          key={step}
          initial={{ x: -100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 100, opacity: 0 }}
          transition={{ duration: 0.3, ease: "easeInOut" as const }}
        >
          {step === "signin" && (
            <SignInForm
              onSuccess={handleClose}
              onSwitchToSignUp={switchToSignUp}
              onSwitchToVerifyEmail={handleSwitchToVerifyEmail}
              setSubmittingForm={setIsSubmittingForm}
            />
          )}
          {step === "signUp" && (
            <SignUpForm
              onSuccess={handleSignupSuccess}
              onSwitchToLogin={switchToSignIn}
              setSubmittingForm={setIsSubmittingForm}
            />
          )}
          {step === "verifyOtp" && email && (
            <VerifyEmail
              email={email}
              onSuccess={handleOtpSuccess}
              switchToLogin={switchToSignIn}
              switchToSignUp={switchToSignUp}
              setSubmittingForm={setIsSubmittingForm}
            />
          )}
        </motion.div>
      </AnimatePresence>
    </ModalLayout>
  );
};

export default AuthModal;
